import React, { Component } from 'react';
import styled from 'styled-components';
import Image from '../Image';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import { Font } from '../../utils/fonts';
import Color from '../../utils/colors';

export const WidthMobile = 324;
export const WidthTablet = 324;
export const WidthDesktop = 359;
export const WidthXDesktop = 405;

class ImageWithCaption extends Component {
    render() {
        const {
            className,
            src,
            firstName,
            lastName,
            profession,
        } = this.props;

        return (
            <Root className={className}>
                <StyledImage src={src} />
                <CaptionWrapper>
                    <FirstName>{firstName}</FirstName>
                    <LastName>{lastName}</LastName>
                    <Profession>{profession}</Profession>
                </CaptionWrapper>
            </Root>
        );
    }
}

const Root = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    
    width: ${WidthMobile}px;
    height: 128px;
    ${mediaWidth.m} {
        width: ${WidthTablet}px;
        height: 128px;
    }
    ${mediaWidth.l} {
        width: ${WidthDesktop}px;
        height: 129px;
    }
    ${mediaWidth.xl} {
        width: ${WidthXDesktop}px;
        height: 187px;
    }
`;

const StyledImage = styled(Image)`
    display: block;
    min-width: 128px;
    width: 128px;
    height: 128px;
    margin-right: 16px;
    ${mediaWidth.m} {
        min-width: 128px;
        width: 128px;
        height: 128px;
    }
    ${mediaWidth.l} {
        min-width: 129px;
        width: 129px;
        height: 129px;
        margin-right: 24px;
    }
    ${mediaWidth.xl} {
        min-width: 187px;
        width: 187px;
        height: 187px;
        margin-right: 32px;
    }
`;

const CaptionWrapper = styled.div`
    ${Font.PRIMARY};
    color: ${Color.TEXT_PRIMARY};
    white-space: pre-line;
`;

const FirstName = styled.div`
    font-size: 24px;
    line-height: 31px;
`;

const LastName = styled(FirstName)`
    margin-bottom: 8px;
`;

const Profession = styled.div`
    font-size: 16px;
    line-height: 21px;
    
    opacity: 0.5;
`;

export default ImageWithCaption;
